export type VehicleCatalogueEnumOption<
  P = {
    name: string;
    value: unknown;
  },
> = {
  value: string;
  label: string;
  shortLabel?: string | null;
  categories?: Array<
    | {
        value: string;
        label: string;
        shortLabel: string;
      }
    | string
  >;
  properties?: Array<Partial<P>>;
  /**
   * Feature subcategory key (only for features)
   */
  subCategory?: string | null;
  children?: Array<VehicleCatalogueEnumOption>;
};
